import React, {PureComponent} from "react"
import {matchPath, useLocation} from "react-router-dom"
import Loading from "@irati/ui/src/Loading"
import {hangPromise} from "@irati/utils/promise"

interface Props {
  routes: () => Promise<any>
  path?: string
  routeProps?: any
}

interface MountedRoutesProps {
  routes: () => Promise<any>
  children: (props: {load: Promise<any>; resolvedRoutes: any}) => any
}

interface State {
  resolvedRoutes: any
  load: Promise<any>
}

class MountedRoutes extends PureComponent<MountedRoutesProps, State> {
  state = {
    load: hangPromise(),
    resolvedRoutes: () => null
  }

  componentDidMount() {
    this.setState({
      load: this.props.routes().then((routes) => {
        this.setState({resolvedRoutes: routes.default})
      })
    })
  }

  render() {
    return this.props.children({load: this.state.load, resolvedRoutes: this.state.resolvedRoutes})
  }
}

/* eslint-disable react/no-multi-comp */
/**
 * Code-splits a set of route definitions.
 *
 * Pass a `routes` loader that resolves to a module exporting a default Routes
 * component. While the promise resolves, the children are wrapped in `Loading`.
 *
 * The resolved `Routes` component is rendered with `routeProps` (defaulting to
 * `{ path }` so nested routes inherit the base path).
 */
const LazyLoad: React.FC<Props> = ({routes, path, routeProps = {path}}) => {
  const location = useLocation()

  if (path && !matchPath({path, end: false}, location.pathname)) {
    return null
  }

  return (
    <MountedRoutes routes={routes}>
      {({load, resolvedRoutes: Routes}) => (
        <Loading load={load}>
          <Routes {...routeProps} />
        </Loading>
      )}
    </MountedRoutes>
  )
}
/* eslint-enable react/no-multi-comp */
export default LazyLoad
